export default __webpack_public_path__ + "static/media/serviceLocation.119dade4.svg";